<script lang="ts" setup>
  import SideBar from '~/components/layout/SideBar.vue'
  import TopBar from '~/components/layout/TopBar.vue'
  import LicenceOverlay from '~/components/auth/LicenceOverlay.vue'
  import DataLoader from '~/components/DataLoader.vue'
  import Submenu from '~/components/layout/Submenu.vue'
  import ReportDownloadsHost from '~/components/reports/downloads/ReportDownloadsHost.vue'
  import { isSubmenuVisible } from '~/composables/useSubmenu'
  import { cn } from '~/lib/utils'

  const { can } = usePermissions()
  const canListReports = can('report', 'list')

  const hasDownloads = computed<boolean>(() => canListReports.value)
</script>

<template>
  <div class="flex flex-1 overflow-hidden bg-[#f5f7f9] justify-between h-dvh w-screen gap-1">
    <DataLoader>
      <SideBar class="flex-none" />
      <div class="flex flex-col flex-1 overflow-hidden">
        <TopBar />
        <div class="flex flex-1 overflow-hidden">
          <Submenu
            :class="
              cn(
                isSubmenuVisible() ? 'w-[200px] md:w-[280px]' : 'w-0',
                'transition-all duration-500 ease-in-out min-w-0 overflow-hidden h-full'
              )
            "
            class="relative"
          />
          <div class="overflow-hidden p-2 pl-1 flex w-full">
            <slot>
              <NuxtPage />
            </slot>
          </div>
        </div>
      </div>
    </DataLoader>
  </div>
  <ReportDownloadsHost v-if="hasDownloads" />
  <LicenceOverlay />
</template>
